require('./bootstrap');

require('alpinejs');

jQuery(function() {

    // Add smooth scrolling to all links
    $("a").on('click', function(event) {
        // Make sure this.hash has a value before overriding default behavior
        if (this.hash !== "") {
            // Prevent default anchor click behavior
            event.preventDefault();

            // Store hash
            var hash = this.hash;

            let home = document.getElementById('home');
            let style = getComputedStyle(home);

            let topContainer = document.getElementById('top-container');
            let topContainerStyle = getComputedStyle(topContainer);
            // let marginTop = parseInt(topContainerStyle.marginTop);

            let topnav = document.getElementById('top-nav');
            let topnavStyle = getComputedStyle(topnav);
            let topHeight = parseInt(topnavStyle.height);
            let scrollpos;
            if ($( window ).width() >= 1200) {
                // desktop
                if (topHeight >= 204) topHeight *= 0.27; // ratio for collapsed height
                scrollpos = $(hash).offset().top - topHeight;
            } else {
                let paddingTop = parseInt(style.paddingTop);
                scrollpos = $(hash).offset().top - paddingTop;
            }

            // // Using jQuery's animate() method to add smooth page scroll
            // // The optional number (800) specifies the number of milliseconds it takes to scroll to the specified area
            $('html, body').stop().animate({
                scrollTop: scrollpos
            }, 800, function(){
                // Add hash (#) to URL when done scrolling (default click behavior)
                // window.location.hash = hash;
            });
        } // End if
    });

    var submitting = false;

    $('#form-register').on('submit', function(e) {
        e.preventDefault();

        if (submitting) return;

        submitting = true;

        // $('.email-error').hide();
        // $('.email-success').hide();
        var form = document.getElementById("form-register");
        var formData = new FormData(form);

        $.ajax({
            url: "/register",
            type: "POST",
            enctype: "multipart/form-data",
            data: formData,
            processData: false,
            contentType: false,
            // dataType: 'JSON',
            success: function(data) {
                if (data && data.success) {
                    $('#form-register').hide();
                    $('.thank-you').show();
                    // $('.email-success').text(data.message);
                    // $('.email-success').show();
                    // $("#form-subscribe")[0].reset();
                }
                submitting = false;
            },
            error: function(xhr, status, error) {
                // $('.email-error').text('*'+xhr.responseJSON.errors.email);
                // $('.email-error').show();
                submitting = false;
            }
        });
    })

    if (location.hash.length > 1) {
        dboxScroll();
    }

    $(window).on('scroll', function (event) {
        dboxScroll();
    });


    function dboxScroll(){
        if($(window).scrollTop() > 250){
            $('nav').addClass('nav-shown');
        } else {
            if($('nav').hasClass('nav-shown')){
                $('nav').removeClass('nav-shown');
            }
        }
    }

    const units = {
        a: {
            "bathroom_1":       {label: 'Bathroom 1',     img: '/img/units/a/TYPE-A-BATHROOM-1.png'},
            "bathroom_2":       {label: 'Bathroom 2',     img: '/img/units/a/TYPE-A-BATHROOM-2.png'},
            "bedroom_1":        {label: 'Room 1',      img: '/img/units/a/TYPE-A-BEDROOM-1-ACTUAL-UNIT.png'},
            "bedroom_2":        {label: 'Room 2',      img: '/img/units/a/TYPE-A-BEDROOM-2.png'},
            "dining":           {label: 'Dining',         img: '/img/units/a/TYPE-A-DINING-ACTUAL-UNIT.png'},
            "kitchen":          {label: 'Kitchen',        img: '/img/units/a/TYPE-A-KITCHEN.png'},
            "living":           {label: 'Living',         img: '/img/units/a/TYPE-A-LIVING-ACTUAL-UNIT.png'},
            "master_bedroom_1": {label: 'Master Room', img: '/img/units/a/TYPE-A-MASTER-BEDROOM-ACTUAL-UNIT.png'},
            "master_bedroom_2": {label: 'Master Room', img: '/img/units/a/TYPE-A-MASTER-BEDROOM-V2.png'}
        },
        c: {
            "studio_bathroom": {label: 'Studio Bathroom', img: '/img/units/c/TYPE-C---STUDIO-BATHROOM.png'},
            "studio_1":        {label: 'Studio',          img: '/img/units/c/TYPE-C---STUDIO-V1.png'},
            "studio_2":        {label: 'Studio',          img: '/img/units/c/TYPE-C---STUDIO-V2.png'},
            "bathroom":        {label: 'Bathroom',        img: '/img/units/c/TYPE-C-BATHROOM.png'},
            "bedroom":         {label: 'Room',         img: '/img/units/c/TYPE-C-BEDROOM-1.png'},
            "kitchen":         {label: 'Kitchen',         img: '/img/units/c/TYPE-C-KITCHEN.png'},
            "living":          {label: 'Living',          img: '/img/units/c/TYPE-C-LIVING.png'},
            "master_bedroom":  {label: 'Master Room',  img: '/img/units/c/TYPE-C-MASTER-BEDROOM.png'}
        }
    };

    const btn_type_holder = $('.btn-type-holder');
    btn_type_holder.empty();

    $.each(units, function (index, el) {
        const type_button = $('<button>').addClass('btn-type').attr({type: 'button', 'data-type': index});
        type_button.html('Type <strong class="unit-type fs-4">'+index+'</strong>');
        type_button.on('click', function(e) {
            $('.btn-type').removeClass('active');
            $(this).addClass('active');
            const type = $(this).data('type');
            // $('.type-text-holder .label').text(type);
            populate_buttons(units[type]);
        });
        btn_type_holder.append(type_button);
    });

    function populate_buttons(data)
    {
        const btn_area_holder = $('.btn-area-holder');
        btn_area_holder.empty();
        $.each(data, function(i, v) {
            const button = $('<button>').addClass('btn-area').attr({type: 'button', 'data-img': v.img});
            button.text(v.label);

            button.on('click', function(e) {
                $('.btn-area').removeClass('active');
                $(this).addClass('active');

                $.each($('.virtual-wrapper .img-holder img'), function(i, el) {
                    $(el).fadeOut(1000, function() {
                        $(this).remove();
                    });
                });

                const new_img = $('<img>').addClass('img-fluid').attr('src', $(this).data('img'));
                $('.virtual-wrapper .img-holder').append(new_img);
                new_img.fadeIn(500);
            });
            btn_area_holder.append(button);
        });
        $('.btn-area').first().trigger('click');
    }

    $('.btn-type').first().trigger('click');

    //begin preloading images after a delay to let other assets finish loading first
    setTimeout(function() {
        $.each(units, function (i, el) {
            $.each(el, function(i, item) {
                $('<img>').attr('src', item.img);
            })
        })
    }, 2000);


});

AOS.init();